import { Header } from 'components/Layout/Header/Header';
import { PetForm } from 'components/Pet/Form/PetForm';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getMarketplace } from 'reducers/marketplace/MarketplaceSelectors';
import { Pet } from 'types/Pet';
import { saveFormsInvitationPetThunk } from 'actions/formsInvitation/FormsInvitationActions';

import { OneColumnLayout } from 'components/Layout/OneColumn/OneColumnLayout';

interface AddPetProps {
    currentStep: number;
    totalSteps: number;
    onBack: () => void;
}

export const AddPet: React.FC<AddPetProps> = props => {
    const dispatch = useDispatch();
    const marketplace = useSelector(getMarketplace);

    const formRef = React.useRef<{ submit: () => void }>(null);

    const submitHandler = async (pet: Pet) => {
        try {
            await dispatch(saveFormsInvitationPetThunk(pet));
            // Navigate back to pet list after successful save
            props.onBack();
        } catch (error) {
            console.error('Error saving pet:', error);
        }
    };

    return (
        <OneColumnLayout header={<Header logo={marketplace.logo} onBack={props.onBack} />}>
            <h1 className="h2 underlined w-full">Add Pet</h1>

            <PetForm
                ref={formRef}
                showSubmitButton
                submitButtonColor={'primary'}
                submitButtonLabel={'save'}
                onSubmit={submitHandler}
            />
        </OneColumnLayout>
    );
};
